import React from 'react';
import { useHistory } from 'react-router-dom';
import { DropdownItem } from 'reactstrap';

const styles = {
  dropdownItem: { fontWeight: 'bold', float: 'left' },
};

function NotificationOptions({ data }) {
  const history = useHistory();

  const onClick = () => {
    if (!data?.length) {
      return;
    }

    history.push('/users/approval-requests');
  };

  const renderDropdownOption = (msg, key) => {
    return (
      <DropdownItem key={key}>
        <div
          onClick={onClick}
          className="nav-link bottom-devider d-flex justify-content-between align-items-center text-center"
        >
          <div style={styles.dropdownItem}>{msg}</div>
          <div className="notify-circle" />
        </div>
      </DropdownItem>
    );
  };

  if (!data?.length) {
    return renderDropdownOption('No Notifications');
  }

  return data.map((item, index) => {
    return renderDropdownOption(item.message, index);
  });
}

export default NotificationOptions;
